export default {
  NaN:        NaN,
  E:          Math.E,
  LN2:        Math.LN2,
  LN10:       Math.LN10,
  LOG2E:      Math.LOG2E,
  LOG10E:     Math.LOG10E,
  PI:         Math.PI,
  SQRT1_2:    Math.SQRT1_2,
  SQRT2:      Math.SQRT2,
  MIN_VALUE:  Number.MIN_VALUE,
  MAX_VALUE:  Number.MAX_VALUE
};
